import {
    mainChartApiUpdateHelper
} from "~/components/child/tradingViewMainChart/utils/helpers/api/mainChartApiUpdateHelper";

export const nearRealTimeDataUpdateHelper = (nearRealTimeData) => {
    mainChartApiUpdateHelper.event("main_chart_data", JSON.stringify(nearRealTimeData));
}